import { type ReactNode } from 'react';

import {
  type TaxReturnCalculationConnection,
  type TaxReturnRequestRuntime,
  TaxReturnRuntimeProvider
} from '@dec/shared';

import { GlobalTaxReturnContext } from '../../../GlobalTaxReturnContext';
import { type FormDefinitionResponse } from '../../../models/definition.types';
import { type Period } from '../../../models/types';
import { TaxReturnNotificationsConnection } from '../../../services/hubConnection';

interface Props {
  children: ReactNode;
  runtime: TaxReturnRequestRuntime<FormDefinitionResponse, Period> & { readOnly: boolean };
  connection?: TaxReturnCalculationConnection;
}

export const FormProviders = ({ children, runtime, connection }: Props) => (
  <TaxReturnRuntimeProvider context={GlobalTaxReturnContext} value={runtime}>
    <TaxReturnNotificationsConnection.Provider value={{ connection: connection as any }}>
      {children}
    </TaxReturnNotificationsConnection.Provider>
  </TaxReturnRuntimeProvider>
);
